import React, { useState } from 'react';
import { ShieldIcon, PlusIcon, XIcon, CheckIcon } from 'lucide-react';
import { mockGuardrailData } from '../utils/mockData';
const Guardrails = () => {
  const [topics, setTopics] = useState(mockGuardrailData);
  const [newTopic, setNewTopic] = useState('');
  const handleToggleTopic = id => {
    setTopics(topics.map(topic => topic.id === id ? {
      ...topic,
      enabled: !topic.enabled
    } : topic));
  };
  const handleAddTopic = () => {
    if (newTopic.trim()) {
      const newId = Math.max(...topics.map(t => t.id)) + 1;
      setTopics([...topics, {
        id: newId,
        name: newTopic.trim(),
        enabled: true,
        custom: true
      }]);
      setNewTopic('');
    }
  };
  const handleDeleteTopic = id => {
    setTopics(topics.filter(topic => topic.id !== id));
  };
  return <div className="space-y-6" data-id="element-260">
      <div className="flex items-center justify-between" data-id="element-261">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-262">Guardrails</h1>
        <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-md flex items-center" data-id="element-263">
          <ShieldIcon size={18} className="mr-2" data-id="element-264" />
          <span className="font-medium" data-id="element-265">Content Moderation Active</span>
        </div>
      </div>
      <p className="text-gray-600" data-id="element-266">
        Configure content moderation by enabling or disabling sensitive topics.
        When enabled, content related to these topics will be blocked.
      </p>
      {/* Add New Topic */}
      <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-267">
        <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-268">
          Add Custom Topic
        </h2>
        <div className="flex space-x-2" data-id="element-269">
          <input type="text" value={newTopic} onChange={e => setNewTopic(e.target.value)} placeholder="Enter topic name" className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-270" />
          <button onClick={handleAddTopic} disabled={!newTopic.trim()} className={`px-4 py-2 rounded-md transition-colors flex items-center ${newTopic.trim() ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'}`} data-id="element-271">
            <PlusIcon size={16} className="mr-2" data-id="element-272" />
            Add Topic
          </button>
        </div>
      </div>
      {/* Topics List */}
      <div className="bg-white rounded-lg shadow-sm" data-id="element-273">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-274">
          <h2 className="text-lg font-medium text-gray-800" data-id="element-275">
            Moderation Topics
          </h2>
        </div>
        <ul className="divide-y divide-gray-200" data-id="element-276">
          {topics.map(topic => <li key={topic.id} className="px-6 py-4 flex items-center justify-between" data-id="element-277">
              <div className="flex items-center" data-id="element-278">
                <span className={`mr-3 text-sm font-medium ${topic.custom ? 'text-purple-600' : 'text-gray-900'}`} data-id="element-279">
                  {topic.name}
                </span>
                {topic.custom && <span className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded" data-id="element-280">
                    Custom
                  </span>}
              </div>
              <div className="flex items-center space-x-3" data-id="element-281">
                <button onClick={() => handleToggleTopic(topic.id)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${topic.enabled ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-282">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${topic.enabled ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-283" />
                </button>
                {topic.custom && <button onClick={() => handleDeleteTopic(topic.id)} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-284">
                    <XIcon size={18} data-id="element-285" />
                  </button>}
              </div>
            </li>)}
        </ul>
      </div>
      {/* Save Settings */}
      <div className="flex justify-end" data-id="element-286">
        <button className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors flex items-center" data-id="element-287">
          <CheckIcon size={18} className="mr-2" data-id="element-288" />
          Save Guardrail Settings
        </button>
      </div>
    </div>;
};
export default Guardrails;